import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import { getJobMilestoneHistory } from '../api/jobDetailApi';

export function useJobMilestoneHistory(jobId: number) {
  return useQuery({
    queryKey: queryKeys.jobs.milestoneHistory(String(jobId)),
    queryFn: () => getJobMilestoneHistory(jobId),
    enabled: jobId > 0,
  });
}
